import type { SegmentType } from '@rcs/data-schema';
import { PEDALING_MAX_SPEED } from '@rcs/renderer';
import type { SampledTrack } from '@rcs/track-geometry';

/** 走った距離 `s` のところの、区間の種類（制御点ごとの区間種別から引く。周回コースは、周回を数えない）。 */
export function segmentKindAt(
  track: SampledTrack,
  segmentKinds: readonly SegmentType[] | undefined,
  s: number,
): SegmentType | undefined {
  if (segmentKinds === undefined || track.count === 0) return undefined;
  const wrapped = track.closed ? ((s % track.length) + track.length) % track.length : s;
  const index = Math.min(track.count - 1, Math.max(0, Math.round(wrapped / track.spacing)));
  const segment = track.segment[index];
  return segment === undefined ? undefined : segmentKinds[segment];
}

/** これより遅いと、止まっているとみなして、こがない [m/s]。 */
const PEDALING_MIN_SPEED = 0.3;

/**
 * 自転車の人が、ペダルをこいでいるか：通常・ブロック区間を、動いていて、速すぎないあいだ。
 * 巻き上げ（チェーン）・ブレーキ・駅・発進加速（装置が進める区間）では、こがない。
 * 速すぎる（約 50 km/h 以上）ときは、こがずに惰性で進む。
 */
export function isPedaling(kind: SegmentType | undefined, speed: number): boolean {
  if (kind !== undefined && kind !== 'normal' && kind !== 'block') return false;
  return speed > PEDALING_MIN_SPEED && speed < PEDALING_MAX_SPEED;
}
